import angular from 'angular';
import uiRouter from 'angular-ui-router';
import PendingSpendingComponent from './pendingspending.component';

let PendingSpendingModule = angular.module('PendingSpending', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newPendingSpending', {
            url: '/pending-spendings/new',
            component: 'pendingSpending',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN', 'VOUCHERS'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editPendingSpending', {
            url: '/pending-spendings/:id',
            component: 'pendingSpending',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN', 'VOUCHERS', 'VOUCHERCOLLECTOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                pendingSpending: (
                    PendingSpendingsService,
                    $stateParams
                ) => {
                    return PendingSpendingsService.findOne({
                        filter: {
                            where: {
                                id: $stateParams.id
                            },
                            include: ['srcVoucher'],
                            deleted: true
                        }
                    });
                }
            }
        });
})
.component('pendingSpending', PendingSpendingComponent)
.name;

export default PendingSpendingModule;
